export const VISITOR_LANGUAGE_CODES = [
  "fa",
  "en",
  "ar",
  "ku",
  "tr",
  "az",
  "ru",
  "uk",
  "es",
  "ro",
  "pl",
  "de",
  "it",
  "hi",
  "fr",
  "nl",
  "ps",
  "uz",
  "hy",
  "zh",
  "ja",
  "ko",
];

export const VISITOR_LANGUAGE_OPTIONS = [
  { code: "fa", label: "فارسی" },
  { code: "en", label: "English" },
  { code: "ar", label: "عربی" },
  { code: "ku", label: "کردی" },
  { code: "tr", label: "ترکی استانبولی" },
  { code: "az", label: "ترکی آذری" },
  { code: "ru", label: "روسی" },
  { code: "uk", label: "اکراینی" },
  { code: "es", label: "اسپانیایی" },
  { code: "ro", label: "رومانی" },
  { code: "pl", label: "لهستانی" },
  { code: "de", label: "آلمانی" },
  { code: "it", label: "ایتالیایی" },
  { code: "hi", label: "هندی" },
  { code: "fr", label: "فرانسوی" },
  { code: "nl", label: "هلندی" },
  { code: "ps", label: "پشتو" },
  { code: "uz", label: "ازبکی" },
  { code: "hy", label: "ارمنی" },
  { code: "zh", label: "چینی" },
  { code: "ja", label: "ژاپنی" },
  { code: "ko", label: "کره‌ای" },
];

export const RTL_LANGUAGES = ["fa", "ar", "ku", "ps"];

export function normalizeLanguage(code) {
  const lang = String(code || "fa").toLowerCase();
  return VISITOR_LANGUAGE_CODES.includes(lang) ? lang : "fa";
}

export function isRtlLanguage(code) {
  return RTL_LANGUAGES.includes(normalizeLanguage(code));
}

export function getLanguageLabel(code) {
  return (
    VISITOR_LANGUAGE_OPTIONS.find(
      (option) => option.code === normalizeLanguage(code)
    )?.label || "فارسی"
  );
}
